import React, { useState, useEffect, useRef, useCallback } from "react";
import axios from "axios";
import { db } from "../firebase-config";
import {
  setDoc,
  getDocs,
  getDoc,
  doc,
  collection,
  increment,
  query,
  where,
} from "firebase/firestore";
import "./Home.css";
import { useParams, useNavigate, Link } from "react-router-dom";
import Alert from "@material-ui/lab/Alert";
import {
  Container,
  List,
  Typography,
  CardContent,
  Paper,
  Grid,
  Button,
  Snackbar,
} from "@material-ui/core";
import { Check } from "@material-ui/icons";
import { Swipeable, direction } from "react-deck-swiper";
import classNames from "classnames";
import CardButton from "../components/CardButton";
import Card from "../components/Card";
import useStyles from "../styles";
import tmdbSvg from "../images/tmdb.svg";

function Home() {
  const { sessionId } = useParams();
  const [updatedSessionId, setUpdatedSessionId] = useState("");
  const navigate = useNavigate();
  const classes = useStyles();
  const [streams, setStreams] = useState([]);
  const [matches, setMatches] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [openCopyAlert, setOpenCopyAlert] = useState(false);
  const [openNewMatchAlert, setOpenNewMatchAlert] = useState(false);
  const [, updateState] = useState();
  const forceUpdate = useCallback(() => updateState({}), []);
  const [data, setData] = useState([]);

  const handleCopyButtonClick = () => {
    // copy the value of the element.
    navigator.clipboard.writeText(`streampal.web.app/${updatedSessionId}`);
    setOpenCopyAlert(true);
  };

  const handleCopyButtonClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenCopyAlert(false);
  };

  const handleNewMatchAlertClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenNewMatchAlert(false);
  };

  const existsInMatches = (id) => {
    return matches.some((item) => id === item.id);
  };

  const handleOnSwipe = async (swipeDirection, movieId) => {
    console.log("Inside handleOnSwipe", swipeDirection, movieId);
    if (swipeDirection === direction.RIGHT) {
      // setLastSwipeDirection("your right");
      await addLike(movieId);
      let movie = await getMovie(movieId);
      console.log("getMovie result", movie);
      if (movie !== undefined && movie.likeCount > 1) {
        console.log(matches, "matches before push");
        setOpenNewMatchAlert(true);
        getMovieDetails(movieId).then((response) => {
          console.log("inside getMovieDetails", response);
          if (!existsInMatches(movieId)) {
            setMatches([
              ...matches,
              { likeCount: movie.likeCount, ...response },
            ]);
          } else {
            matches.map((item) => {
              if (item.id === movieId) {
                item.likeCount = movie.likeCount;
              }
            });
          }
        });
        console.log(matches, "matches.length after push");
      }
    }

    if (swipeDirection === direction.LEFT) {
      // setLastSwipeDirection("your left");
    }

    setStreams((prev) => prev.slice(1));

    if (streams.length <= 1) {
      fetchMovies(currentPage + 1);
      setCurrentPage(currentPage + 1);
    }
  };

  const renderButtons = ({ right, left }) => (
    <CardButton right={right} left={left} />
  );

  var random_id = function () {
    return Math.random().toString(36).slice(2, 8);
  };

  const API_ROOT = "https://api.themoviedb.org/3/discover/movie";
  const API_KEY = process.env.REACT_APP_TMDB_API_KEY;

  const getApiUrl = function (query) {
    query.api_key = API_KEY;
    const search = Object.keys(query)
      .map(
        (paramKey) =>
          `${encodeURIComponent(paramKey)}=${encodeURIComponent(
            query[paramKey]
          )}`
      )
      .join("&");
    return `${API_ROOT}${search ? "?" : ""}${search}`;
  };

  const setPageUrl = () => {};

  const fetchMovies = (currentPageIndex) => {
    fetch(
      getApiUrl({
        language: "en-US",
        page: currentPageIndex,
        primary_release_year: new Date().getFullYear(),
      })
    )
      .then((response) => response.json())
      .then((body) => {
        setStreams([...body.results]);
      });
  };

  const getMovieDetails = (movieId) => {
    try {
      return fetch(
        `https://api.themoviedb.org/3/movie/${movieId}?api_key=${process.env.REACT_APP_TMDB_API_KEY}`
      )
        .then((response) => response.json())
        .then((body) => {
          return body;
        });
    } catch (e) {
      console.log("Error inside getMovieDetails", e);
    }
  };
  const fetchMatches = async () => {
    // Get ids from the Firebase DB
    console.log("sessionId inside fetchMatches", updatedSessionId);
    try {
      const likedMoviesCollection = collection(
        db,
        "sessions",
        updatedSessionId.toString(),
        "likes"
      );
      // Create a query against the collection.
      const q = query(likedMoviesCollection, where("likeCount", ">", 1));
      const querySnapshot = await getDocs(q);
      const resultMatchesIds = [];
      querySnapshot.forEach((doc) => {
        resultMatchesIds.push({ id: doc.id, ...doc.data() });
      });
      console.log("Current matches in DB: ", resultMatchesIds);

      // Get movie details from the TMDB API
      const resultingMatches = [];
      resultMatchesIds.forEach((movie) => {
        getMovieDetails(movie.id).then((response) => {
          console.log("inside getMovieDetails", response);
          resultingMatches.push({ likeCount: movie.likeCount, ...response });
        });
      });
      console.log("Current matches after TMDB fetch: ", resultingMatches);
      // setMatches(prevMovies => ([...prevMovies, ...resultingMatches]));
      setMatches(resultingMatches);
      // forceUpdate();
    } catch (e) {
      console.log("error fetchMatches", e);
    }
  };

  useEffect(() => {
    async function doAsyncUpdate() {
      if (sessionId === undefined || sessionId === "") {
        navigate("/" + random_id());
      }
      const pathname = window.location.pathname.slice(1);
      setUpdatedSessionId(pathname);
      console.log("sessionId:" + sessionId);
      console.log("pathname:" + pathname);
      console.log("updatedSessionId:" + updatedSessionId);
      await fetchMovies(currentPage);
      await fetchMatches();
      axios
        .get("https://jsonplaceholder.typicode.com/users")
        .then((result) => setData(result.data));
    }
    doAsyncUpdate();
  }, [updatedSessionId]);

  useEffect(() => {
    async function doAsyncUpdate() {
      await fetchMatches();
    }
  }, [matches]);

  const addLike = async (movieId) => {
    try {
      const likedMoviesCollection = collection(
        db,
        "sessions",
        updatedSessionId.toString(),
        "likes"
      );
      console.log("inside addLike and id is:", movieId);
      await setDoc(
        doc(likedMoviesCollection, movieId.toString()),
        {
          likeCount: increment(1),
        },
        { merge: true }
      );
    } catch (e) {
      console.log("error addLike", e);
    }
  };

  const getMovie = async (movieId) => {
    try {
      const likedMoviesCollection = collection(
        db,
        "sessions",
        updatedSessionId.toString(),
        "likes"
      );
      console.log("inside getMovie and id is:", movieId);
      let docSnap = await getDoc(
        doc(likedMoviesCollection, movieId.toString())
      );
      if (docSnap.exists()) {
        console.log("Document data:", docSnap.data());
        return docSnap.data();
      } else {
        // doc.data() will be undefined in this case
        console.log("No such document!");
        return;
      }
    } catch (e) {
      console.log("error getMovie", e);
    }
  };

  return (
    <Container maxWidth="sm">
      <Typography className={classNames(classes.marginTop2)} variant="h3">
        StreamPal{" "}
        <span role="img" aria-label="awesome">
          {" "}
          🚀
        </span>
      </Typography>
      {/* <form noValidate> */}
      <Typography align="center" variant="body1">
        Kinda like a dating app but you match with movies and shows. Share,
        filter, and swipe till you match with something great to watch.
      </Typography>
      <Typography className={classNames(classes.marginTop2)} variant="h5">
        Your Shareable Link
      </Typography>
      <Typography variant="body1">
        Copy this link and share it with your group!
      </Typography>
      <Paper style={{ backgroundColor: "MediumAquaMarine" }} variant="outlined">
        <CardContent>
          <Typography align="center" variant="h6">
            {`streampal.web.app/${updatedSessionId}`}
          </Typography>
          <Typography
            align="center"
            style={{ marginBottom: 12 }}
            variant="body2"
            component="p"
          ></Typography>
          <div
            className={classNames(classes.marginTop2, classes.centerContent)}
          >
            <Button
              style={{ backgroundColor: "turquoise" }}
              size="large"
              color="primary"
              variant="outlined"
              onClick={handleCopyButtonClick}
            >
              Copy to Clipboard
            </Button>
          </div>
        </CardContent>
      </Paper>
      <Snackbar
        open={openCopyAlert}
        autoHideDuration={1000}
        onClose={handleCopyButtonClose}
      >
        <Alert
          icon={<Check fontSize="inherit" />}
          onClose={handleCopyButtonClose}
          severity="success"
        >
          Link copied successfully!
        </Alert>
      </Snackbar>
      <div className={classNames(classes.marginTop2, classes.centerContent)}>
        <Link to={`/`} target="_blank" rel="noopener noreferrer">
          Create a New Session
        </Link>
      </div>
      <Typography className={classNames(classes.marginTop2)} variant="h5">
        Your Services &#38; Filters
      </Typography>
      <Typography variant="body1">
        Services and filter will be added here soon!
      </Typography>

      <Typography className={classNames(classes.marginTop2)} variant="h5">
        Swipe
      </Typography>
      <Typography variant="body1">Try swiping the card below!</Typography>
      <Grid container spacing={3} className={classes.centerContent}>
        <Grid
          item
          xs={12}
          className={classNames(classes.marginTop2, classes.centerContent)}
        >
          {currentPage < 1000 && streams.length > 0 ? (
            <Swipeable
              renderButtons={renderButtons}
              onSwipe={(event) => handleOnSwipe(event, streams[0].id)}
            >
              <Card key={streams[0].id} item={streams[0]} />
              {/* // {streams.map((stream) => (
              //    <Card item={stream} />
              // ) */}
            </Swipeable>
          ) : (
            <Typography variant="body1">
              Looks like you have reached the end here ={")"}
            </Typography>
          )}
        </Grid>
      </Grid>
      <Typography className={classNames(classes.marginTop2)} variant="h5">
        Matches ({matches.length})
      </Typography>
      <Typography variant="body1">
        Your matches will appear below once your group starts swiping!
      </Typography>
      <Snackbar
        open={openNewMatchAlert}
        autoHideDuration={3000}
        onClose={handleNewMatchAlertClose}
      >
        <Alert
          icon={<Check fontSize="inherit" />}
          onClose={handleNewMatchAlertClose}
          severity="success"
        >
          New match is found!
        </Alert>
      </Snackbar>
      <Grid container spacing={3} className={classes.centerContent}>
        <List dense={true}>
          {matches.map((match, id) => (
            <Grid
              key={id}
              item
              xs={12}
              className={classNames(classes.marginTop2, classes.centerContent)}
            >
              {" "}
              <Card key={id} item={match} />
            </Grid>
          ))}
          {/* {data.map((item) => (
            <li key={item.username}>
              {item.username}: {item.name}
            </li>
          ))} */}
        </List>
      </Grid>
      <Grid
        item
        xs={12}
        className={classNames(classes.marginTop2, classes.centerContent)}
      >
        <Typography variant="body1">
          {"Made with "}
          <span role="img" aria-label="github">
            ❤️
          </span>
          {"by "}
          <a
            href="https://ya332.github.com"
            rel="noopener noreferrer"
            target="_blank"
          >
            Yigit Alparslan
          </a>{" "}
        </Typography>
      </Grid>
      <Grid
        item
        xs={12}
        className={classNames(classes.marginTop2, classes.centerContent)}
      >
        <img src={tmdbSvg} className={classes.tmdb} alt="tmdb" />
      </Grid>
      <Grid
        item
        xs={12}
        className={classNames(classes.marginTop2, classes.centerContent)}
      >
        <Typography variant="body1">
          &copy; {new Date().getFullYear()} All Rights Reserved
        </Typography>
      </Grid>
    </Container>
  );
}
export default Home;
